import createItemsGroupsArray from './createItemsGroupsArray';
import sortByTheMostCommonFirstLetter from './sortByTheMostCommonFirstLetter';

export default items => {
    const itemsPerGroup = 10;
    const itemsCount = items.length;
    const itemsGroups = createItemsGroupsArray(itemsCount, itemsPerGroup);
    const itemsSortedByItsNameMostCommonFirstLetter = sortByTheMostCommonFirstLetter(items);

    itemsSortedByItsNameMostCommonFirstLetter.forEach(item => {
        const itemsGroupIsNotFilledYet = itemsGroup => itemsGroup.length < itemsPerGroup;
        const itemHasUniqueFirstLetter = itemsGroup =>
            itemsGroup.every(groupedItem => {
                const groupedItemNameFirstLetter = groupedItem[0].charAt(0);
                const itemNameFirstLetter = item[0].charAt(0);

                return groupedItemNameFirstLetter !== itemNameFirstLetter;
            });

        const matchedGroup = itemsGroups.find(
            itemsGroup => itemsGroupIsNotFilledYet(itemsGroup) && itemHasUniqueFirstLetter(itemsGroup)
        );

        matchedGroup ? matchedGroup.push(item) : itemsGroups[itemsGroups.length - 1].push(item);
    });

    return itemsGroups;
};
